import { z } from 'zod';

export const deadLetterListQuerySchema = z.object({
    status: z.enum(['pending', 'retried', 'abandoned']).optional().default('pending'),
    limit: z.coerce.number().int().min(1).max(500).optional().default(100),
    page: z.coerce.number().int().min(1).optional().default(1),
    pageSize: z.coerce.number().int().min(1).max(100).optional().default(20),
    eventName: z.string().optional(),
    hopCountMin: z.coerce.number().int().min(0).optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});

export const deadLetterRetryAllBodySchema = z.object({
    status: z.enum(['pending']).optional().default('pending'),
    eventName: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).optional().default(50),
});

export const deadLetterAbandonAllBodySchema = z.object({
    status: z.enum(['pending']).optional().default('pending'),
    eventName: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).optional().default(50),
});

export const deadLetterPurgeBodySchema = z.object({
    olderThanDays: z.coerce.number().int().min(1).max(365).default(7),
    status: z.enum(['abandoned', 'retried']).default('abandoned'),
});
